import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.submitting = false
    this.handleSubmit = this.onSubmit.bind(this)
    this.handleSubmitStart = this.disableSubmit.bind(this)
    this.handleSubmitEnd = this.enableSubmit.bind(this)

    this.element.addEventListener("submit", this.handleSubmit)
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit)
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  onSubmit(event) {
    if (!this.submitting) {
      this.submitting = true
      this.disableSubmit()
      return
    }

    event.preventDefault()
    event.stopImmediatePropagation()
  }

  disableSubmit() {
    this.submitElements.forEach((submit) => {
      submit.disabled = true
      submit.dataset.originalText ||= submit.textContent
      submit.textContent = document.documentElement.dataset.i18nFormSubmittingLabel
    })
  }

  enableSubmit(event) {
    if (event?.detail?.success) return

    this.submitting = false
    this.submitElements.forEach((submit) => {
      submit.disabled = false
      if (submit.dataset.originalText) submit.textContent = submit.dataset.originalText
    })
  }

  get submitElements() {
    if (this.hasSubmitTarget) return this.submitTargets

    return Array.from(this.element.querySelectorAll("button[type='submit'], input[type='submit']"))
  }
}
